<!-- 单据list的查询 -->
<div class="time-body">
  <nz-range-picker class="data-picker" [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-range-picker>
  <input nz-input class="input-search" [placeholder]="'Common.ListSearchPlaceholder' | translate "
    [(ngModel)]="inputValue" />
  <button class="button-search" nz-button nzType="default" (click)="submit()">
    <em nz-icon nzType="search"></em>
    {{ 'Common.Query' | translate }}
  </button>
  <br />
</div>